<template>

  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="leave_approval_status_list" class="elevation-1" :search="search">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Leave Approval Status</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="mb-2 button" v-on="on">Add Leave Approval Status</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.status" persistent-hint
                          :hint="editedIndex==-1?'For example :: Approved,Rejected':'For example :: Approved,Rejected'"
                          label="Enter Leave Approval Status" :rules="[v => !!v || 'required']" rounded outlined dense>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.displayName" persistent-hint
                          :hint="editedIndex==-1?'For example :: Approved,Rejected':'For example :: Approved,Rejected'"
                          label="Enter Display Name" :rules="[v => !!v || 'required']" rounded outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
      <template v-slot:[`item.biometrictopayroll`]="{ item }">
        <v-switch @change="toggle(item)" v-model="item.biometrictopayroll"></v-switch>
      </template>

    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      valid: false,
      // extraBreadcrumbItems: [
      //   { text: "Leave Approval Status", disabled: true, href: "" },

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      overlay:false,
    errorMsg: {
      castId: false
    },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'status',
        },  
        {
          text: 'Display Name',
          align: 'left',
          sortable: false,
          value: 'displayName',
        },          
        {
          text: 'Is Active?',
          align: 'left',
          sortable: false,
          value: 'isactive',
        },   
        {
          text: 'Biometric To Payroll?',
          align: 'left',
          sortable: false,
          value: 'biometrictopayroll',
        },   
        { text: 'Actions', value: 'action', sortable: false },
      ],
      leave_approval_status_list: [],
      editedIndex: -1,
      editedItem: {
        leaveApprovalStatusId: '',
        status: '',      
        displayName:'' ,    
        isActive:true,    
      },
      defaultItem: {
        leaveApprovalStatusId: '',
        status: '',     
        displayName:'', 
        isActive:true,           
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Leave Approval' : 'Edit Leave Status'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },
    mounted(){
      this.onLoad()       
     },
    methods: {
       toggle(item){
            const data = {
              id: item.id,
              biometrictopayroll: item.biometrictopayroll,
          };
          axios
              .post("/LeaveManagement/markLeaveApprovalStatus", data)
              .then((res) => {
                  if (res.data.flag == "YES") {
                      this.showSnackbar("#4caf50", "Updated Successfully..."); // show snackbar on success
                      this.onLoad();
                  } else {
                      this.showSnackbar("#b71c1c", "Something went wrong!!!");
                      sessionStorage.setItem("error-trace", res.data.error_trace);
                  }
              })
              .catch((error) => {
                  window.console.log(error);
              })
              .finally(() => {});
      },
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad(){      
      this.overlay=true;
          axios
      .post("/LeaveManagement/getLeaveApprovalStatusList")
      .then(res => {
        if (res.data.msg == "200") {
          if(this.load = true){
            this.overlay=false;
            this.leave_approval_status_list = res.data.leave_approval_status_list;
            //window.alert(JSON.stringify(this.leave_approval_status_list))
          }
        } else {
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        var overlay=false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem (item) {
        this.editedIndex = this.leave_approval_status_list.indexOf(item)        
        this.dialog = true
        this.editedItem.status = item.status       
        this.editedItem.displayName = item.displayName
        this.editedItem.isActive = item.isactive
        this.editedItem.leaveApprovalStatusId = item.id    
    },

      // deleteItem (item) {
      //   const index = this.language_super_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save() {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/LeaveManagement/editLeaveApprovalStatus", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {
                  Object.assign(
                    this.leave_approval_status_list[this.editedIndex],
                    this.editedItem
                  );
                  this.showSnackbar(
                    "#4caf50",
                    "Leave Approval Status Updated Successfully..."
                  ); // show snackbar on success
                  this.onLoad();
                }
                else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Leave Approval Status Already Present!!!"); // show snackbar on error
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close();
          }
        } else {         
            axios
              .post("/LeaveManagement/saveLeaveApprovalStatus", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {                  
                  this.leave_approval_status_list.push(this.editedItem);
                  this.showSnackbar("#4caf50", "Leave Approval Status Added Successfully..."); // show snackbar on success
                  this.onLoad()
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Leave Approval Status Already Present!!!"); // show snackbar on error
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close(); 
        }
      }, // end of save()

      isValidated() {
        if (this.editedItem.leaveApprovalStatusId) {
          return true;
        } else {
          if (!this.editedItem.leaveApprovalStatusId) {
            this.errorMsg.leaveApprovalStatusId = true;
          }

          return false;
        }
      } // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>